import { create } from 'zustand'
import { getGame } from './api'
import type { GetGameResponse } from '@/tygo/dto'

interface GameStore {
  game: GetGameResponse | null
  isLoading: boolean
  error: string | null
  fetchGame: (gameId: string) => Promise<void>
  setGame: (game: GetGameResponse) => void
  clearGame: () => void
}

export const useGameStore = create<GameStore>((set) => ({
  game: null,
  isLoading: false,
  error: null,

  fetchGame: async (gameId: string) => {
    set({ isLoading: true, error: null })
    try {
      const game = await getGame(gameId)
      set({ game, isLoading: false })
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : 'Unknown error',
        isLoading: false,
      })
    }
  },

  setGame: (game) => set({ game }),
  clearGame: () => set({ game: null, error: null }),
}))
